// src/components/DiagnosticsPill.jsx
// Inside the phone app there is no developer console: when something went wrong, a small "Diagnostics" pill appears; tapping
// it shows what the app noted (errors and the steps of starting the offline engine and of signing in), for a screenshot.
import React, { useEffect, useState } from 'react';
import { diagnosticEntries, subscribeToDiagnostics } from '../diagnostics';
import { isNativeApp } from '../native';

function DiagnosticsPill() {
    const [entries, setEntries] = useState([...diagnosticEntries()]);
    const [open, setOpen] = useState(false);
    useEffect(() => subscribeToDiagnostics((all) => setEntries([...all])), []);

    const problems = entries.filter((entry) => entry.level === 'error').length;
    if (!isNativeApp() || (problems === 0 && !open)) return null;
    return (
        <div className="diagnostics">
            {open ? (
                <div className="diagnostics-panel" role="dialog" aria-label="Diagnostics">
                    <div className="diagnostics-head">
                        <strong>Diagnostics</strong>
                        <button className="btn btn-sm" onClick={() => setOpen(false)}>
                            Close
                        </button>
                    </div>
                    <ol>
                        {[...entries].reverse().map((entry, index) => (
                            <li key={index} className={`diag-${entry.level}`}>
                                <span>{entry.at}</span> {entry.text}
                            </li>
                        ))}
                    </ol>
                </div>
            ) : (
                <button className="diagnostics-pill" onClick={() => setOpen(true)}>
                    Diagnostics ({problems})
                </button>
            )}
        </div>
    );
}

export default DiagnosticsPill;
